(function () {
  'use strict';

  angular.module('socket.pusher', ['ngResource']);
})();
